import { Cascader } from 'antd';
import styled from 'styled-components';

export default styled(Cascader)`
	// Add your styles here
`;
